import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from 'rxjs';
import { Data } from "./DataService";

@Injectable({
  providedIn: 'root'
})
export class AlertsService {
  public doShowAlert = new BehaviorSubject(false);
  checkForAlerts: Subject<any> = new Subject<any>();
  constructor(public dataStore: Data) {
  }
  // showAlert(alertType:number, alertMsg:string, timeout: number = 5000){
  //     this.checkForAlerts.next({alertType: alertType, alertMsg: alertMsg, timeout: timeout});
  // }
  showAlert(alertType: number, alertMsg: string, timeout: number = 5000) {
    this.dataStore.showToastr({
      message: alertMsg,
      type: 'success'
    });
  }
  updateAlert(val) {
    this.doShowAlert.next(val);
  }
}